import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The title steps of the #163 type scale (`design-tokens.css`). Registered as
 * font sizes so `cn("text-pane-title", "text-muted-foreground")` keeps both:
 * unregistered, tailwind-merge would read `text-pane-title` as a colour and
 * drop it in favour of the later colour class.
 */
const twMerge = extendTailwindMerge({
  extend: { theme: { text: ["page-title", "section-title", "pane-title"] } },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
